<template>
  <div class="border">
    <!--<el-row type="flex" style="margin-top: 20px;margin-bottom: 20px;">-->
      <!--<el-col :span="24">-->
        <!--<el-breadcrumb separator="/">-->
          <!--<el-breadcrumb-item>{{this.strategy.name}}</el-breadcrumb-item>-->
          <!--<el-breadcrumb-item>组件池</el-breadcrumb-item>-->
        <!--</el-breadcrumb>-->
      <!--</el-col>-->
    <!--</el-row>-->
    <el-form :inline="true" :model="searchForm" class="demo-form-inline" label-position="right" label-width="10px">
      <el-form-item label=" ">
        <el-input v-model="searchForm.queryValue" clearable width="500px" placeholder="搜索：code，组件名称"></el-input>
      </el-form-item>
      <el-form-item label=" ">
        <el-select v-model="searchForm.hasAction" clearable placeholder="是否有动作" style="padding-top: 1px">
          <el-option label="是" :value="true"/>
          <el-option label="否" :value="false"/>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="pageIndex=1;list();">搜索</el-button>
      </el-form-item>
      <el-form-item style="float: right;padding-right: 30px" >
        <!--<el-button type="primary" icon="el-icon-plus" @click="showAddFlag = true">新增组件</el-button>-->
        <el-dropdown @command="handleCommand">
          <el-button type="primary">
            新增组件<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item style="background-color: #E4E7ED" v-for="item in globalConfig.itemTypes" :key="item.value" :command="item.value">{{item.label}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-form-item>
    </el-form>
    <template>
      <el-tabs v-model="activeName" @tab-click="handleClick" type="card">
        <el-tab-pane v-for="item in tabsConfig" :key="item.value" :label="item.label" :name="`${item.value}`">
          <el-table ref="componentTable" :data="tableData" border stripe highlight-current-row @selection-change="handleSelectionChange">
            <el-table-column prop="buildName" label="组件" header-align="center" align="center" :formatter="buildName"/>
            <el-table-column prop="type" label="组件类型" header-align="center" align="center" :formatter="formatItemType"/>
            <el-table-column prop="updatedAt" label="更新时间" header-align="center" align="center"/>
            <el-table-column label="动作" header-align="center" align="center">
              <template slot-scope="scope">
                <el-tooltip placement="right-end" effect="light" v-if="(JSON.parse(scope.row.viewData)).ruleActions && (JSON.parse(scope.row.viewData)).ruleActions.length > 0">
                  <el-button>动作</el-button>
                  <div slot="content">
                    <div v-for="(item, i) in (JSON.parse(scope.row.viewData)).ruleActions" :key="i">{{item.resultType}}->{{item.actionTag}}->{{item.action}}</div>
                  </div>
                </el-tooltip>
                <span v-else></span>
              </template>
            </el-table-column>
            <el-table-column prop="useStatus" label="使用状态" header-align="center" align="center">
              <template slot-scope="scope">
                {{scope.row.useStatus === 1 ? '使用中' : '未使用'}}
              </template>
            </el-table-column>
            <el-table-column prop="refStatus" label="引用状态" header-align="center" align="center">
              <template slot-scope="scope">
                <el-tooltip placement="right-end" effect="light" v-if="scope.row.refInfos && scope.row.refInfos.length > 0">
                  <el-button>{{scope.row.refStatus === 1 ? '被引用' : '未引用'}}</el-button>
                  <div slot="content">
                    <el-tree :data="scope.row.refInfos" :props="defaultProps"></el-tree>
                  </div>
                </el-tooltip>
                <span v-else>{{scope.row.refStatus === 1 ? '被引用' : '未引用'}}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" header-align="center" align="center">
              <template slot-scope="scope">
                <el-button icon="el-icon-edit" @click="openComponent(scope.row.type, scope.row)" type="text" size="mini">编辑</el-button>
                <el-button icon="el-icon-delete" @click="removeComponent(scope.row)" type="text" size="mini" style="color: #F56C6C">删除</el-button>
                <el-button icon="el-icon-share" @click="copyComponent(scope.row)" type="text" size="mini" style="color: #67C23A">拷贝</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            :current-page="pageIndex"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="->,total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </el-tab-pane>
      </el-tabs>
    </template>
    <!--子组件-->
    <decisionTable :ifshow="showDecisionTableFlag" :strategyItem="strategyItem" :strategy="strategy"  @handleCloseDialog="showDecisionTableFlag=false;list();"></decisionTable>
    <scoreCard :ifshow="showScoreCardFlag" :strategyItem="strategyItem" :strategy="strategy"  @handleCloseDialog="showScoreCardFlag=false;list();"></scoreCard>
    <rule :ifshow="showRuleFlag" :strategyItem="strategyItem" :strategy="strategy"  @handleCloseDialog="showRuleFlag=false;list();"></rule>
  </div>
</template>

<script>
import {clone} from '@/utils/common'

export default {
  props: {
    strategy: Object
  },
  data () {
    return {
      strategyItem: {},
      showDecisionTableFlag: false,
      showScoreCardFlag: false,
      showRuleFlag: false,
      activeName: '0',
      searchForm: {
        strategyId: this.strategy.id,
        queryValue: null,
        type: null,
        hasAction: null
      },
      tableData: [],
      component: {},
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      selectIds: [],
      showAddFlag: false,
      showEditFlag: false,
      tabsConfig: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      }
    }
  },
  created () {
    this.tabsConfig = clone(this.globalConfig.itemTypes)
    this.tabsConfig.splice(0, 0, {value: 0, label: '全部'})
    this.searchForm.strategyId = this.strategy.id
    this.list()
  },
  methods: {
    buildName (row) {
      return '[' + row.code + '] ' + row.name
    },
    handleCommand (commond) {
      this.strategyItem = {}
      this.openComponent(commond)
    },
    async openComponent (type, row) {
      if (row) {
        // 加载编辑数据
        try {
          const res = await this.$http.get(`/strategy/item/${row.strategyId}/${row.id}`)
          if (res.code === '200') {
            this.strategyItem = clone(res.data)
          } else {
            this.$message.error('系统异常')
            return
          }
        } catch (err) {
          console.error(err)
          return
        }
        // this.strategyItem = row
      } else {
        this.strategyItem = {}
      }
      // 1：规则、2：决策表、3：评分卡
      switch (type) {
        case 1:
          this.showRuleFlag = true
          break
        case 2:
          this.showDecisionTableFlag = true
          break
        case 3:
          this.showScoreCardFlag = true
          break
        default:
          this.$message.error('类型错误')
          break
      }
    },
    handleClick (tab, event) {
      if (tab.name === '0') {
        this.searchForm.type = null
      } else {
        this.searchForm.type = tab.name
      }
      this.list()
    },
    async list () {
      let params = {
        ...this.searchForm,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      try {
        const res = await this.$http.post('/strategy/item/list', params)
        if (res.code === '200') {
          this.tableData = res.data.rows
          this.total = res.data.total
        } else {
          this.$message.error(res.message)
        }
      } catch (err) {
        console.error(err)
      }
      try {
        const res = await this.$http.post('/strategy/item/count', params)
        if (res.code === '200') {
          for (let t of this.tabsConfig) {
            let flag = true
            for (let a of res.data) {
              if (t.value === a.type) {
                t.label = t.label.replace(/\([0-9]{1,}\)/g, '')
                t.label += '(' + a.count + ')'
                flag = false
                break
              }
            }
            if (flag) {
              t.label = t.label.replace(/\([0-9]{1,}\)/g, '')
              t.label += '(0)'
            }
          }
        } else {
          this.$message.error(res.message)
        }
      } catch (err) {
        console.error(err)
      }
    },
    handleCurrentChange (currentPage) {
      this.pageIndex = currentPage
      this.list()
    },
    handleSizeChange (size) {
      this.pageSize = size
      this.list()
    },
    handleSelectionChange (val) {
      this.selectIds = []
      val.forEach(v => {
        this.selectIds.push(v.id)
      })
    },
    async copyComponent (row) {
      try {
        const res = await this.$http.get(`/strategy/item/${row.strategyId}/${row.id}`)
        if (res.code === '200') {
          this.strategyItem = res.data
          this.showEditFlag = true
        } else {
          this.$message.error(res.message)
          return
        }
      } catch (err) {
        console.error(err)
        return
      }
      this.strategyItem.code = null
      this.strategyItem.id = null
      console.log(this.strategyItem)
      // 1：规则、2：决策表、3：评分卡
      switch (this.strategyItem.type) {
        case 1:
          this.showRuleFlag = true
          break
        case 2:
          this.showDecisionTableFlag = true
          break
        case 3:
          this.showScoreCardFlag = true
          break
        default:
          this.$message.error('类型错误')
          break
      }
    },
    removeComponent (row) {
      const url = `/strategy/item/${row.strategyId}/${row.id}`
      this.$confirm('确认删除吗？', '提示', {type: 'warning'}).then(async () => {
        try {
          const res = await this.$http.delete(url)
          if (res.code === '200') {
            this.$message.success('删除成功!')
            this.list()
          } else {
            this.$message.error(res.message)
          }
        } catch (err) {
          console.error(err)
        }
      }).catch(action => {
      })
    }
  },
  components: {
    'decisionTable': () => import('./decision-table'),
    'scoreCard': () => import('./score-card'),
    'rule': () => import('./rule')
  }
}
</script>

<style lang="stylus">
  .el-tooltip__popper {
    max-width: 40%;
    line-height: 180%;
  }
</style>



// WEBPACK FOOTER //
// src/views/component/list.vue